import { render, staticRenderFns } from "./RegisterRecord.vue?vue&type=template&id=9662e266&"
import script from "./RegisterRecord.vue?vue&type=script&lang=js&"
export * from "./RegisterRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports